export default "/images/00d8fcf8aaff4d241cb4a2fef1ea8ee6.jpg";